// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeftOutlined } from '@ant-design/icons';


// const dist = sessionStorage.getItem("dist");

// const previewContainerStyle = {
//   width: '365px',
//   minHeight: '557px',
//   maxHeight: '667px',
//   margin: '10px auto',
//   border: '1px solid #ccc',
//   borderRadius: '20px',
//   overflow: 'hidden',
//   boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//   backgroundColor: '#f8f9fa',
//   display: 'flex',
//   flexDirection: 'column',
//   fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   color: 'rgb(14, 57, 114)',
// };

// const headerStyle = {
//   height: '100px',
//   backgroundColor: '#fff',
//   boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   fontSize: '20px',
//   fontWeight: 'bold',
//   color: 'rgb(14, 57, 114)',
// };

// const scrollViewStyle = {
//   padding: '20px',
//   overflowY: 'auto',
//   flex: 1,
// };

// const cardStyle = {
//   backgroundColor: '#fff',
//   marginBottom: '10px',
//   padding: '15px',
//   borderRadius: '8px',
//   boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
// };

// const DollarRateWeb = () => {
//   const [dollarData, setDollarData] = useState([]);
//  const navigate = useNavigate();

//   const getDollarData = () => {
//     axios
//       .post('https://lionsdirectoryapi.emedha.in/notification/api/dollar/get', { dist })
//       .then((res) => {
//         setDollarData(res.data);
       
//       })
//       .catch((error) => console.error('Error fetching data:', error));
//   };



//   useEffect(() => {
//     getDollarData();
//   }, []);



//   return (
//     <div style={previewContainerStyle}>
//             <div style={{
//               backgroundColor: '#fff',
//               padding: '15px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between'
//             }}>
//               <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <ArrowLeftOutlined
//                   style={{
//                     fontSize: '18px',
//                     color: '#0e3972',
//                     cursor: 'pointer',
//                     marginRight: '10px'
//                   }}
//                   onClick={() => navigate('/home')} // or the correct route for HomeScreen
//                 />
//                 <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Dollar Rate Info</h6>
//               </div>
//             </div>
 
//       <div style={scrollViewStyle}>
//         {dollarData.map((item, index) => (
//           <div key={index} style={cardStyle}>
//             <div style={{ fontWeight: 'bold', fontSize: '18px' }}>{item.dmonth}</div>
//             <div style={{ color: 'rgb(120, 122, 120)', fontSize: '16px' }}>Rate: {item.drate}</div>
//             <div style={{ fontSize: '16px' }}>Year: {item.dyear}</div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default DollarRateWeb;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ChevronLeft, CircleDollarSign } from 'lucide-react';

const DollarRate = ({ onBack, styles }) => {

  const [rateData, setRateData] = useState([]);
    const districtCode = sessionStorage.getItem("dist");


  useEffect(() => {
    fetchDollarRate();
  }, []);

  const fetchDollarRate = async () => {
    try {
      const res = await axios.post(
        "https://lionsdirectoryapi.emedha.in/notification/api/dollar/get",
        { dist: districtCode }
      );

      setRateData(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={styles.scrollArea}>

      {/* Back Button */}
      <div
        onClick={onBack}
        style={{
          padding: '15px 15px 5px',
          display: 'flex',
          alignItems: 'center',
          color: '#0033A0',
          cursor: 'pointer'
        }}
      >
        <ChevronLeft size={20} />
        <span style={{ fontSize: '14px', fontWeight: '600' }}>
          Back to Home
        </span>
      </div>

      {/* Title */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        padding: '10px 15px 20px'
      }}>
        <div style={{
          backgroundColor: '#FFC20E',
          color: 'white',
          width: '45px',
          height: '45px',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <CircleDollarSign size={28} />
        </div>

        <h1 style={{
          fontSize: '24px',
          color: '#0033A0',
          margin: 0
        }}>
          Dollar Rate
        </h1>
      </div>

      {/* Dynamic Rate Cards */}
      <div style={{ padding: '0 15px' }}>
        {rateData.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '15px',
              marginBottom: '12px',
              border: '1px solid #eee'
            }}
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '10px'
            }}>
              <span style={{
                fontSize: '18px',
                fontWeight: 'bold'
              }}>
                {item.dmonth}
              </span>

              <span style={{
                fontSize: '14px',
                color: '#888'
              }}>
                {item.dyear}
              </span>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <div>
                <div style={{
                  fontSize: '11px',
                  color: '#888'
                }}>
                  Rate
                </div>

                <div style={{
                  fontSize: '16px',
                  fontWeight: 'bold'
                }}>
                  ₹ {item.drate}
                </div>
              </div>
            </div>

          </div>
        ))}

        {rateData.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '20px',
            color: '#888'
          }}>
            No dollar rates available
          </div>
        )}
      </div>

    </div>
  );
};

export default DollarRate;